import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60a7a01a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "accordion-container" }
const _hoisted_2 = ["onClick", "onMouseenter", "onMouseleave"]
const _hoisted_3 = { class: "slide-handler" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reactiveList, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["slide-container", { active: item.active }]),
        key: item.id,
        onClick: ($event: any) => (_ctx.onClickSlide(item)),
        onMouseenter: ($event: any) => (_ctx.onMouseEnter(item)),
        onMouseleave: ($event: any) => (_ctx.onMouseLeave(item)),
        style: _normalizeStyle(`width:${_ctx.gap}px;flex:0 0 ${_ctx.gap}px;background-image: url(${item.image})`)
      }, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(item.id), 1)
      ], 46, _hoisted_2))
    }), 128))
  ]))
}